"use strict";

define('model/meeting',['./base', './meeting.person', 'datakit/util/url'], function (Model, MeetingPerson, url) {
  var Meeting = Model.extend({
    urlRoot: '/rs/api/meeting',
    parse: function parse() {
      var data = Model.prototype.parse.apply(this, arguments) || {};
      _.each(data.people, function (mp) {
        if (mp && mp.person) {
          mp.id = mp.person.id;
        }
      });
      return data;
    },
    defaults: function defaults() {
      return {
        people: [],
        documents: []
      };
    },
    virtual: {
      'group.name': Model.createKeyPathVirtual('group.name'),
      'board.name': Model.createKeyPathVirtual('group.name'),
      'boardName': {
        deps: ['group'],
        get: function get() {
          var board = this.get('group');
          return board ? board.get('name') : null;
        }
      },
      'locked': {
        deps: ['editable'],
        get: function get() {
          return !this.get('editable');
        }
      },
      'editable': {
        deps: ['adjournDate'],
        get: function get() {
          return !this.get('adjournDate');
        }
      }
    },
    childModels: {
      documents: 'Document',
      people: 'MeetingPerson',
      group: 'Board',
      finalizedPerson: 'Person',
      sendAgendaPerson: 'Person'
    },
    validation: {
      group: {
        required: true
      },
      startDate: {
        required: true
      },
      endDate: function endDate(value) {
        if (this.get('startDate') && this.get('startDate') >= value) {
          return 'The end time cannot be before the start time.';
        }
      },
      location: {
        required: true,
        maxLength: 50
      }
    },
    initialize: function initialize() {
      Model.prototype.initialize.apply(this, arguments);
      this.listenTo(this.get('people'), 'add', function (mp) {
        mp.meeting = this;
      });
    },
    addPeople: function addPeople(newPeople) {
      for (var p = 0, len = newPeople.length; p < len; p++) {
        this.addPerson(newPeople[p]);
      }
    },
    addPerson: function addPerson(person) {
      var meetingPeople = this.get('people');
      meetingPeople.add({
        person: person,
        id: person.id
      });
      return this;
    },
    removePerson: function removePerson(person) {
      var meetingPeople = this.get('people');
      var mp = meetingPeople.find(function (mp) {
        return mp.get('person') && mp.get('person').id == person.id;
      });
      if (mp) {
        meetingPeople.remove(mp);
      }
      return this;
    },
    addDocuments: function addDocuments(newDocuments) {
      for (var d = 0, len = newDocuments.length; d < len; d++) {
        this.addDocument(newDocuments[d]);
      }
    },
    addDocument: function addDocument(doc) {
      var docs = this.get('documents');
      docs.add(doc);
      return this;
    },
    addCurrentDoc: function addCurrentDoc(documentId) {
      this.set('currentDocument', documentId);
      return this;
    },
    removeDocument: function removeDocument(doc) {
      var docs = this.get('documents');
      docs.remove(doc);
      return this;
    },
    serializeChildModel: function serializeChildModel(model, options) {
      var data = Model.prototype.serializeChildModel.apply(this, arguments);
      if (model instanceof MeetingPerson) {
        data.present = model.get('present');
      }
      return data;
    },
    start: function start(options) {
      options = _.extend({}, options, {
        type: 'POST',
        url: url.template(this.urlRoot + '/begin/:id', this)
      });
      return this.save(null, options);
    },
    end: function end(options) {
      options = _.extend({}, options, {
        type: 'POST',
        url: url.template(this.urlRoot + '/adjourn/:id', this)
      });
      return this.save(null, options);
    },
    finalize: function finalize(options) {
      options = _.extend({}, options, {
        type: 'POST',
        url: url.template(this.urlRoot + '/finalize/:id', this)
      });
      return this.save(null, options);
    },
    sendAgenda: function sendAgenda(emailMessage) {
      return this.save({}, {
        type: 'POST',
        attrs: emailMessage ? emailMessage.toJSON() : {},
        url: url.template('/rs/api/letter/meeting/:id', this)
      });
    },
    updateNotes: function updateNotes() {
      var options = {
        url: url.template('/rs/api/meetingNotes/:id', this)
      };
      return Model.prototype.save.call(this, null, options);
    },
    getAgendaURL: function getAgendaURL() {
      return url.template(this.urlRoot + '/agenda/:id', this);
    },
    getMinutesURL: function getMinutesURL() {
      return url.template(this.urlRoot + '/minutes/:id', this);
    }
  }, {
    collection: function collection() {
      return this.createCollection('/rs/api/meeting/:start/:end');
    },
    collectionByBoardId: function collectionByBoardId(boardId, start, end) {
      return this.createCollection('/rs/api/meeting/:boardId/:start/:end').params({
        boardId: boardId,
        start: start,
        end: end
      });
    },
    collectionByDocumentId: function collectionByDocumentId(documentId) {
      return this.createCollection('/rs/api/meeting/document/:documentId').params({
        documentId: documentId
      });
    }
  });
  return Meeting;
});

